import { render, staticRenderFns } from "./LateralBarUsers.vue?vue&type=template&id=3c43df36&"
import script from "./LateralBarUsers.vue?vue&type=script&lang=js&"
export * from "./LateralBarUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports